<template>
  <cdr-button
    v-if="virtualTourLinkModel.enabled"
    tag="a"
    :href="virtualTourLinkModel.href"
    data-ui="store-hero-image-button"
  >
    <virtual-tour-union-icon
      slot="icon-right"
      inherit-color
    />
    {{ virtualTourLinkModel.text }}
  </cdr-button>
</template>
<script>
import { CdrButton } from '@rei/cedar';
import VirtualTourUnionIcon from './union-icon/VirtualTourUnionIcon.vue';

export default {
  name: 'VirtualTourButton',
  components: {
    CdrButton,
    VirtualTourUnionIcon,
  },
  props: {
    virtualTourLinkModel: {
      type: Object,
      required: true,
    },
  },
};
</script>
